import { err, ok, type Result } from '../result.ts';

// Procedure and imaging orders (docs/plans/phase1-consultation.md §2.8). A request is
// performed or cancelled; a performed order is amended (its outcome, with a reason) or
// entered in error. Nothing is deleted.

export const SERVICE_ORDER_KINDS = ['procedure', 'imaging'] as const;
export type ServiceOrderKind = (typeof SERVICE_ORDER_KINDS)[number];

export const SERVICE_ORDER_STATUSES = [
  'requested',
  'performed',
  'cancelled',
  'entered_in_error',
] as const;
export type ServiceOrderStatus = (typeof SERVICE_ORDER_STATUSES)[number];

export const SERVICE_ORDER_ACTIONS = ['perform', 'cancel', 'amend', 'enter_in_error'] as const;
export type ServiceOrderAction = (typeof SERVICE_ORDER_ACTIONS)[number];

export function serviceOrderTransition(
  from: ServiceOrderStatus,
  action: ServiceOrderAction,
): Result<ServiceOrderStatus, 'service_order.not_allowed'> {
  if (from === 'requested' && action === 'perform') return ok('performed');
  if (from === 'requested' && action === 'cancel') return ok('cancelled');
  if (from === 'performed' && action === 'amend') return ok('performed');
  if (from === 'performed' && action === 'enter_in_error') return ok('entered_in_error');
  return err('service_order.not_allowed');
}
